import { ChangeEvent, useEffect, useState } from 'react';
import { SelectItemProps } from '@ui/src';
import { v4 as uuid } from 'uuid';
import { UseFormSetValue } from 'react-hook-form';
import { COFAndIndividualQuestionnarieFormValues } from '../../../../hoc/individual/types';

let emailsTimeout: NodeJS.Timeout;

const useStepOne = ({
  clientsActivities,
  sourcesOfFunds,
  questionnarieSetValue,
  questionnarieFields,
}: {
  clientsActivities?: SelectItemProps[];
  sourcesOfFunds?: SelectItemProps[];
  questionnarieSetValue: UseFormSetValue<COFAndIndividualQuestionnarieFormValues>;
  questionnarieFields?: COFAndIndividualQuestionnarieFormValues;
}) => {
  const [additionalEmails, setAdditionalEmails] = useState<
    { id: string; email: string }[]
  >([
    {
      id: `email-${uuid()}`,
      email: '',
    },
  ]);

  const employmentActivity = clientsActivities?.find(
    (item) => item.name === 'Employment',
  );
  const otherActivity = clientsActivities?.find(
    (item) => item.name === 'Other',
  );
  const businessOwnerActivity = clientsActivities?.find(
    (item) => item.name === 'Business Owner',
  );

  const otherSourceOfFunds = sourcesOfFunds?.find(
    (item) => item.name === 'Other',
  );

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    clearTimeout(emailsTimeout);

    const nextEmails = additionalEmails?.map((item) => {
      const result = { ...item };

      if (e.target.name === `email-${result.id}`) {
        result.email = e.target.value;
      }

      return result;
    });

    emailsTimeout = setTimeout(() => {
      questionnarieSetValue(
        'emails',
        nextEmails?.filter((item) => item.email)?.map((item) => item.email),
      );
    }, 700);

    setAdditionalEmails(nextEmails);
  };

  const onDeleteAdditionalEmails = (id: string) => {
    const nextEmails = additionalEmails?.filter((item) => item.id !== id);

    setAdditionalEmails(nextEmails);
    questionnarieSetValue(
      'emails',
      nextEmails?.filter((item) => item.email)?.map((item) => item.email),
    );
  };

  useEffect(() => {
    if (questionnarieFields?.emails?.length) {
      setAdditionalEmails(
        questionnarieFields?.emails?.map((item) => ({
          id: `email-${uuid()}`,
          email: item,
        })),
      );
    }
  }, []);

  return {
    additionalEmails,
    onChangeEmail,
    onDeleteAdditionalEmails,
    setAdditionalEmails,
    employmentActivity,
    otherActivity,
    businessOwnerActivity,
    otherSourceOfFunds,
  };
};

export default useStepOne;
